import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import LearnMorePage from "./pages/LearnMorePage";
import CareerPage from "./pages/CareerPage";
import CommunityPage from "./pages/CommunityPage";
import PrivacyPage from "./pages/PrivacyPage";
import FMALMelbourne from "./pages/FMALMelbourne";
import FMALGoldCoast from "./pages/FMALGoldCoast";
import FMALCairns from "./pages/FMALCairns";
import FMALPerth from "./pages/FMALPerth";
import FMALNewSouthWales from "./pages/FMALNewSouthWales";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/learn-more" element={<LearnMorePage />} />
          <Route path="/career" element={<CareerPage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/fmal-melbourne" element={<FMALMelbourne />} />
          <Route path="/fmal-gold-coast" element={<FMALGoldCoast />} />
          <Route path="/fmal-cairns" element={<FMALCairns />} />
          <Route path="/fmal-perth" element={<FMALPerth />} />
          <Route path="/fmal-new-south-wales" element={<FMALNewSouthWales />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
